import React, { memo } from "react";

import BaseNode from "../Base/Base";
import type AssetTypes from "../../../../../../../enums/assetTypes";
import { type FlowItemScorm } from "../../../types";
import { type FlowItemBase } from "../types";
import ScormCard from "../../../../../../../components/cards/flowDesignerDropCard/ScormCard/ScormCard";

interface ScormNodeNodeOwnProps {
  type: AssetTypes.Scorm;
  data: FlowItemScorm & FlowItemBase;
}

const ScormNode: React.FC<ScormNodeNodeOwnProps> = ({ type, data }) => {
  return (
    <BaseNode data={data}>
      <ScormCard item={{ ...data, elementType: type }} />
    </BaseNode>
  );
};

export default memo(ScormNode);
